import { loginContainer } from "./login.css";
import { LoginProps } from "./types";

const Login = ({ children }: LoginProps) => {
  return <div className={loginContainer}>{children}</div>;
};

export default Login;
